import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import ModelTableDto from '../dto/ModelTableDto';

class ModelTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'modelTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<ModelTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, ModelTableDto)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} name
	 * @param {string} simulationId
	 * @return {Promise<string>}
	 */
	addLummusBySimulationId(name, simulationId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/addLummusBySimulationId`, {
					name,
					simulationId
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} driverId
	 * @param {string} name
	 * @param {number} version
	 * @param {string} simulationId
	 * @param {string} subscriptionKey
	 * @return {Promise<string>}
	 */
	addLummus2BySimulationId(driverId, name, version, simulationId, subscriptionKey) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/addLummus2BySimulationId`, { driverId, name, version, simulationId, subscriptionKey })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

}

export default new ModelTableService();
